import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import {
    SESSION_KWIKAPI_TOKEN,
    SESSION_USER,
} from "../config.js"

import {
    getSSOUser,
} from "../services/auth"

export default function SSO() {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const login = async () => {
            const token = params.get("token");

            if (!token) {
                navigate("/login");
                return;
            }

            try {
                const response = await getSSOUser(token);

                if (!response.ok) {
                    navigate("/login", { replace: true });
                    return;
                }

                const data = await response.json();

                localStorage.setItem(SESSION_KWIKAPI_TOKEN, token);
                localStorage.setItem(SESSION_USER, JSON.stringify(data));

                navigate("/home", { replace: true });
            } catch {
                navigate("/login", { replace: true });
            }
        };

        login();
    }, [navigate, params]);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100vw",
                height: "80vh",
            }}
        >
            <CircularProgress />
        </Box>
    );
}
